export function camelToSnakeCase (str, toLowerCase = true) {
  const _str = str.replace(/([a-z])([A-Z])/g, '$1_$2')

  return toLowerCase
    ? _str.toLowerCase()
    : _str
}

export function transformAnalyticsDataToSurvicate (data) {
  if (!data) return

  return Object.keys(data).reduce((acc, key) => {
    return {
      ...acc,
      [camelToSnakeCase(key)]: String(data[key]),
    }
  }, {})
}
